import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["_inputRender", "avatarImg", "avatarProps", "badge", "countryIconId", "destructive", "disabled", "icon", "iconId", "multiSelect", "paymentIconId", "selected", "shortcut", "supportingText", "text", "textLeadingType", "textNode"],
  _excluded2 = ["sx"];
/* eslint-disable sort-keys */
import React from 'react';
import { useTheme, styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MuiMenuItem from '@mui/material/MenuItem';
import { Avatar } from '../Avatar';
import { Icon } from '../Icon';
import { Badge } from '../Badge';
import { Checkbox } from '../Checkbox';
import { CountryIcon } from '../CountryIcon';
import { PaymentIcon } from '../PaymentIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function MenuItem(_ref) {
  var _inputRender = _ref._inputRender,
    avatarImg = _ref.avatarImg,
    avatarProps = _ref.avatarProps,
    badge = _ref.badge,
    countryIconId = _ref.countryIconId,
    destructive = _ref.destructive,
    disabled = _ref.disabled,
    icon = _ref.icon,
    iconId = _ref.iconId,
    multiSelect = _ref.multiSelect,
    paymentIconId = _ref.paymentIconId,
    selected = _ref.selected,
    shortcut = _ref.shortcut,
    supportingText = _ref.supportingText,
    text = _ref.text,
    textLeadingType = _ref.textLeadingType,
    textNode = _ref.textNode,
    others = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var _ref2 = badge || {},
    badgeSx = _ref2.sx,
    badgeProps = _objectWithoutProperties(_ref2, _excluded2);
  var destructiveColor = theme.palette.error[700];
  return /*#__PURE__*/_jsxs(StyledMenuItem, _extends({}, others, {
    className: textLeadingType === 'dotLeading' ? "dotLeading".concat(destructive ? ' dotLeading-destructive' : '') : '',
    disabled: disabled,
    padding: _inputRender ? 'false' : 'true',
    selected: selected,
    tabIndex: 0,
    "data-element": "StyledMenuItem",
    "data-component": "MenuItem",
    "data-source-file": "MenuItem.tsx",
    children: [multiSelect && /*#__PURE__*/_jsx(Box, {
      sx: {
        mr: 2
      },
      children: /*#__PURE__*/_jsx(Checkbox, {
        checked: selected,
        disabled: disabled,
        size: "sm"
      })
    }), countryIconId && /*#__PURE__*/_jsx(CountryIcon, {
      id: countryIconId,
      size: 20,
      sx: {
        color: theme.palette.gray[500],
        mr: 2
      }
    }), paymentIconId && /*#__PURE__*/_jsx(PaymentIcon, {
      id: paymentIconId,
      size: 20,
      sx: {
        color: theme.palette.gray[500],
        mr: 2
      }
    }), !countryIconId && (icon || iconId) && textLeadingType === 'iconLeading' && /*#__PURE__*/_jsx(Typography, {
      color: theme.palette.gray[500],
      component: "div",
      sx: {
        mr: '8px'
      },
      children: icon ? icon : iconId && /*#__PURE__*/_jsx(Icon, {
        color: destructive ? destructiveColor : theme.palette.gray[500],
        iconId: iconId,
        size: 20
      })
    }), textLeadingType === 'avatarLeading' && /*#__PURE__*/_jsx(Avatar, _extends({
      src: avatarImg
    }, avatarProps, {
      size: 'xs',
      sx: {
        mr: '8px'
      }
    })), /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        textAlign: 'left'
      },
      "data-element": "Box",
      "data-source-file": "MenuItem.tsx",
      children: [/*#__PURE__*/_jsx(Typography, {
        color: destructive ? destructiveColor : theme.palette.gray[900],
        sx: {
          marginRight: supportingText ? 2 : 0
        },
        variant: "text-md-regular",
        "data-element": "Typography",
        "data-source-file": "MenuItem.tsx",
        children: textNode != null ? textNode : text
      }), supportingText && /*#__PURE__*/_jsx(Typography, {
        color: destructive ? destructiveColor : theme.palette.gray[500],
        variant: "text-md-regular",
        children: supportingText
      })]
    }), badge && /*#__PURE__*/_jsx(Badge, _extends({
      size: 'sm',
      sx: _extends({
        ml: 2
      }, badgeSx)
    }, badgeProps)), !_inputRender && shortcut && /*#__PURE__*/_jsx(Shortcut, {
      color: theme.palette.gray[600],
      variant: "text-sm-regular",
      children: shortcut
    }), !_inputRender && !multiSelect && selected && /*#__PURE__*/_jsx(Icon, {
      className: "MenuItem-selected-check",
      color: theme.palette.primary[600],
      iconId: "Check",
      size: 20,
      sx: {
        marginLeft: 'auto'
      }
    })]
  }));
}
var StyledMenuItem = styled(MuiMenuItem)(function (_ref3) {
  var padding = _ref3.padding,
    theme = _ref3.theme;
  return {
    '&.Mui-selected': {
      '&:hover': {
        backgroundColor: theme.palette.gray[50]
      },
      '&:focus': {
        backgroundColor: theme.palette.gray[50]
      },
      backgroundColor: theme.palette.gray[50]
    },
    '&.MuiSvgIcon-root': {
      color: theme.palette.gray[500],
      height: '20px',
      width: '20px'
    },
    '&.dotLeading': {
      '&:before': {
        backgroundColor: theme.palette.success[500],
        borderRadius: '100%',
        content: '""',
        height: '8px',
        marginRight: '8px',
        width: '8px'
      },
      alignItems: 'center'
    },
    '&.dotLeading-destructive:before': {
      backgroundColor: theme.palette.error[500]
    },
    '&:focus-visible': {
      '& .MuiCheckbox-root': {
        borderRadius: '6px',
        boxShadow: "0px 0px 0px 4px ".concat(theme.palette.primary[100]),
        height: 'inherit',
        width: 'inherit'
      },
      backgroundColor: 'transparent',
      boxShadow: "0px 0px 0px 4px ".concat(theme.palette.gray[100])
    },
    '&:hover': {
      '.MuiSvgIcon-root': {
        color: theme.palette.gray[700]
      },
      '.MenuItem-selected-check > .MuiSvgIcon-root': {
        color: theme.palette.primary[600]
      },
      '& .MuiCheckbox-root': {
        '.MuiSvgIcon-root': {
          backgroundColor: theme.palette.primary[100],
          border: 'solid',
          borderColor: theme.palette.primary[600],
          borderWidth: 1,
          color: theme.palette.primary[600]
        },
        backgroundColor: theme.palette.primary[100]
      },
      backgroundColor: theme.palette.gray[50]
    },
    borderRadius: '8px',
    padding: padding === 'false' ? 0 : '10px 8px',
    ':not(:last-of-type)': {
      marginBottom: padding === 'false' ? 0 : '4px'
    },
    marginBottom: 0
  };
});
var Shortcut = styled(Typography)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    background: theme.palette.gray[50],
    border: "1px solid ".concat(theme.palette.gray[100]),
    borderRadius: '4px',
    marginLeft: 'auto',
    padding: '2px 4px'
  };
});